// This is mostly deprecated
import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface LayoutState {
    headerHeight: number;
    sectionHeaderHeight: number;
    itemHeight: number;
    paginationHeight: number;
}

const initialState: LayoutState = {
    headerHeight: 0,
    sectionHeaderHeight: 0,
    itemHeight: 166,
    paginationHeight: 72,
};

const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setHeaderHeight(state: LayoutState, action: PayloadAction<number>) {
            state.headerHeight = action.payload;
        },
        setSectionHeaderHeight(
            state: LayoutState,
            action: PayloadAction<number>
        ) {
            state.sectionHeaderHeight = action.payload;
        },
        setItemHeight(state: LayoutState, action: PayloadAction<number>) {
            state.itemHeight = action.payload;
        },
        setPaginationHeight(state: LayoutState, action: PayloadAction<number>) {
            state.paginationHeight = action.payload;
        },
    },
});

export const getLayoutMeasurements = (state: RootState) => state.layout;

export const getHeaderHeight = createSelector(
    [getLayoutMeasurements],
    layout => layout.headerHeight
);
export const getSectionHeaderHeight = createSelector(
    [getLayoutMeasurements],
    layout => layout.sectionHeaderHeight
);
export const getItemHeight = createSelector(
    [getLayoutMeasurements],
    layout => layout.itemHeight
);
export const getPaginationHeight = createSelector(
    [getLayoutMeasurements],
    layout => layout.paginationHeight
);

export const {
    setHeaderHeight,
    setSectionHeaderHeight,
    setItemHeight,
    setPaginationHeight,
} = layoutSlice.actions;
export const layoutReducer = layoutSlice.reducer;
